import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { ReactComponent as PlaySvg } from '../assets/play.svg';
import { ReactComponent as PauseSvg } from '../assets/pause.svg';

const ControlsContainer = styled(Box)(() => ({
  display: 'inline-flex',
  flexDirection: 'column',
  width: '18.75rem',
  height: '3.25rem',
  backgroundColor: '#FFF',
  padding: '0 1.25rem',
  zIndex: 20,
  boxShadow:
    '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  borderRadius: '36px',
  '& .controls': {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto 0',
  },
  '& .controlsIcon': {
    width: '1.875rem',
    height: '1.875rem',
    cursor: 'pointer',
  },
  '& .controlsIcon--small': {
    width: '1.375rem',
    height: '1.375rem',
    cursor: 'pointer',
  },
}));

const Timecontrols = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  position: 'absolute',
  height: '3.25rem',
  left: '1.875rem',
  '& .time_progressbarContainer': {
    display: 'flex',
  },
  '& .time_progressBar': {
    backgroundColor: 'gray',
    borderRadius: '15px',
    width: '13.75rem',
    height: '0.3125rem',
    zIndex: 30,
    position: 'relative',
    margin: '0 1.25rem',
    accentColor: '#000',
  },
  '& .controlsIcon--small': {
    width: '1.375rem',
    height: '1.375rem',
    cursor: 'pointer',
  },
}));

export default function VideControls({ videoRef }) {
  const [playing, setPlaying] = useState(true);
  const [wasPlaying, setWasPlaying] = useState(true);
  const [progress, setProgress] = useState(0);

  const videoHandler = (control) => {
    if (control === 'play') {
      videoRef.current.play();
      setPlaying(true);
    } else if (control === 'pause') {
      videoRef.current.pause();
      setPlaying(false);
    }
  };

  useEffect(() => {
    if (playing) {
      videoRef?.current?.play();
    } else {
      videoRef?.current?.pause();
    }
  }, [playing, videoRef]);

  useEffect(() => {
    const video = videoRef.current;

    const interval = setInterval(() => {
      // eslint-disable-next-line
      const progress = (video.currentTime / video.duration) * 1000;
      setProgress(progress);
    }, 42);

    return () => {
      clearInterval(interval);
    };
  }, [videoRef]);

  const handleVideoProgress = (event) => {
    const manualChange = Number(event.target.value);
    videoRef.current.currentTime =
      (videoRef.current.duration / 1000) * manualChange;
    setProgress(manualChange);
  };

  return (
    <>
      <ControlsContainer>
        <div className="controls">
          {playing ? (
            <PauseSvg
              onClick={() => videoHandler('pause')}
              className="controlsIcon--small"
            />
          ) : (
            <PlaySvg
              onClick={() => videoHandler('play')}
              className="controlsIcon--small"
            />
          )}
        </div>
      </ControlsContainer>
      <Timecontrols>
        <div className="time_progressbarContainer">
          <input
            className="time_progressBar"
            type="range"
            min="0"
            max="1000"
            value={progress}
            onChange={handleVideoProgress}
            onMouseDown={() => {
              setWasPlaying(playing);
              setPlaying(false);
            }}
            onMouseUp={() => {
              setPlaying(wasPlaying);
            }}
          />
        </div>
      </Timecontrols>
    </>
  );
}
